import { getEffectiveTranslations } from './i18n';

function t(lang, key) { return getEffectiveTranslations(lang||'en')[key]||key; }

// ── BeeLove Events System ─────────────────────────────────────────────────

export function getEventTypes(lang){return {
  speed_dating:  { label:'Speed Dating',    color:'#C9A84C', icon:'💘' },
  apero:         { label:'Apéro réseau',    color:'#7EB8A0', icon:'🥂' },
  themed:        { label:'Soirée thème',    color:'#A084C9', icon:'🎭' },
  vip:           { label:'VIP',             color:'#E2C06E', icon:'✦'  },
  partner:       { label:'Partenaire',      color:'#C97A7A', icon:'🤝' },
  outdoor:       { label:'Outdoor',         color:'#7AA8C9', icon:'🌿' },
};
}
export const EVENT_TYPES = getEventTypes('en');


// DEV ONLY — real events loaded from Supabase events_full view
// Kept for fallback when Supabase is not configured
export function getMockEvents(lang) { return [
  {
    id: 'evt_001',
    type: 'speed_dating',
    title: 'BeeLove Speed Dating — Plateau',
    subtitle: t(lang,'event.desc_premat'),
    date: '2025-04-12',
    time: '19:00',
    endTime: '22:00',
    location: 'Café Resonance',
    address: '5175 Ave du Parc, Montréal',
    network: 'ca_montreal',
    capacity: 30,
    registered: 18,
    price: 35,
    priceHoney: 31.50,
    priceGold: 28,
    priceVIP: 0, // free for Gold
    status: 'published',
    image: 'https://images.unsplash.com/photo-1510337550647-e84c83c48a3d?w=800&q=80&auto=format&fit=crop',
    description: 'Meet 8–10 compatible singles over drinks. Our algorithm pre-selects your best matches from attendees — so you already know before you walk in.',
    highlights: ['Pre-matched by BeeLove algorithm','Professional host','Welcome drink included','Private match reveals at 10pm'],
    ageRange: [24, 38],
    tags: ['dating','social','drinks'],
    sponsorId: null,
    vipOnly: false,
    goldFree: true,
  },
  {
    id: 'evt_002',
    type: 'apero',
    title: 'Apéro Montréal-Nord',
    subtitle: 'Casual drinks — no pressure',
    date: '2025-04-19',
    time: '18:30',
    endTime: '21:30',
    location: 'Bar Le Ritz PDB',
    address: '179 Jean-Talon O, Montréal',
    network: 'ca_montreal',
    capacity: 50,
    registered: 31,
    price: 18,
    priceHoney: 16.20,
    priceGold: 14.40,
    priceVIP: 0,
    status: 'published',
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80&auto=format&fit=crop',
    description: 'Relaxed apéro for BeeLove Montréal members. Come as you are, meet new people, no speed dating pressure. Badge verified members only.',
    highlights: [t(lang,'event.perk_verified'),'Open bar (2 drinks included)','Live DJ','Free entry for Bee Gold'],
    ageRange: [22, 42],
    tags: ['casual','social','drinks','music'],
    sponsorId: null,
    vipOnly: false,
    goldFree: true,
  },
  {
    id: 'evt_003',
    type: 'themed',
    title: 'Soirée Cuisiniers·ères',
    subtitle: t(lang,'event.desc_cooking'),
    date: '2025-05-03',
    time: '17:00',
    endTime: '21:00',
    location: 'Ateliers & Saveurs',
    address: '444 Viger O, Montréal',
    network: 'ca_montreal',
    capacity: 20,
    registered: 7,
    price: 45,
    priceHoney: 40.50,
    priceGold: 36,
    priceVIP: 0,
    status: 'published',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80&auto=format&fit=crop',
    description: 'Cook a 3-course meal with singles who share your love of food. Teams of 4 are formed by BeeLove compatibility. Dinner together at the end.',
    highlights: [t(lang,'event.perk_ingredients'),'3-course menu','Wine pairing','BeeLove compatibility teams'],
    ageRange: [25, 45],
    tags: ['food','cooking','themed','intimate'],
    sponsorId: 'partner_001',
    vipOnly: false,
    goldFree: false,
  },
  {
    id: 'evt_004',
    type: 'vip',
    title: 'Bee Gold Exclusive — Rooftop',
    subtitle: t(lang,'event.desc_vip'),
    date: '2025-04-26',
    time: '20:00',
    endTime: '23:30',
    location: 'Terrasse Nelligan',
    address: '106 Saint-Paul O, Montréal',
    network: 'ca_montreal',
    capacity: 24,
    registered: 12,
    price: 55,
    priceHoney: 49.50,
    priceGold: 0,
    priceVIP: 0,
    status: 'published',
    image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&q=80&auto=format&fit=crop',
    description: 'Exclusive rooftop evening for Bee Gold members. Open bar, live music, curated guest list. 1 complimentary event per quarter for Gold subscribers.',
    highlights: [t(lang,'event.perk_openbar'),t(lang,'event.perk_jazz'),'Curated guest list (max 24)','Complimentary for Bee Gold'],
    ageRange: [25, 45],
    tags: ['vip','rooftop','exclusive','drinks','music'],
    sponsorId: null,
    vipOnly: true,
    goldFree: true,
  },

  // ── PAST EVENTS ──────────────────────────────────────────────────────────
  {
    id: 'evt_past_001',
    type: 'speed_dating',
    title: 'BeeLove Speed Dating — Février',
    subtitle: t(lang,'event.desc_premat'),
    date: '2025-02-14',
    time: '19:00', endTime: '22:00',
    location: 'Bar Le Lab', address: '1351 Rachel Est, Montréal',
    network: 'ca_montreal', capacity: 24, registered: 24, confirmed: 19,
    price: 35, priceHoney: 31.50, priceGold: 28,
    status: 'past',
    image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&q=80&auto=format&fit=crop',
    description: 'Valentine speed dating — sold out. 19 of 24 attendees confirmed.',
    highlights: ['Pre-matched by algorithm','Valentine theme','Match reveals at midnight'],
    ageRange: [22, 36], goldFree: false, vipOnly: false,
    attendees: [
      { id:'u001', name:'Camille Lefebvre',  photo:'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=200&q=80&auto=format&fit=crop', mutual:true },
      { id:'u003', name:'Léa Rousseau',      photo:'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=200&q=80&auto=format&fit=crop', mutual:false },
      { id:'u005', name:'Sophie Martin',     photo:'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=200&q=80&auto=format&fit=crop', mutual:false },
      { id:'u008', name:'Valentin Chevalier',photo:'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80&auto=format&fit=crop', mutual:false },
      { id:'u012', name:'Inès Durand',       photo:'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80&auto=format&fit=crop', mutual:false },
      { id:'u015', name:'Yasmine Hadjadj',   photo:'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&q=80&auto=format&fit=crop', mutual:false },
    ],
  },
  {
    id: 'evt_past_002',
    type: 'apero',
    title: 'Apéro Hiver — Le Plateau',
    subtitle: t(lang,'event.desc_premat'),
    date: '2025-01-18',
    time: '18:30', endTime: '21:30',
    location: 'Dieu du Ciel', address: '29 Ave Laurier O, Montréal',
    network: 'ca_montreal', capacity: 40, registered: 38, confirmed: 31,
    price: 0, status: 'past',
    image: 'https://images.unsplash.com/photo-1543007630-9710e4a00a20?w=800&q=80&auto=format&fit=crop',
    description: 'Casual winter apéro — free event, great vibes.',
    highlights: ['Free entry','Craft beers','Meet your matches in person'],
    ageRange: [21, 40], goldFree: false, vipOnly: false,
    attendees: [
      { id:'u002', name:'Lucas Moreau',    photo:'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80&auto=format&fit=crop', mutual:true },
      { id:'u006', name:'Maxime Bernard',  photo:'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&q=80&auto=format&fit=crop', mutual:false },
      { id:'u009', name:'Clara Fontaine',  photo:'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80&auto=format&fit=crop', mutual:false },
      { id:'u011', name:'Thomas Leroy',    photo:'https://images.unsplash.com/photo-1463453091185-61582044d556?w=200&q=80&auto=format&fit=crop', mutual:false },
    ],
  },

];
}

// DEV SEED ONLY — data in supabase/seed/dev_seed.sql
export const MOCK_EVENTS = getMockEvents('en');

// DEV SEED ONLY — data in supabase/seed/dev_seed.sql
export const MOCK_PARTNERS = [
  { id:'partner_001', name:'Ateliers & Saveurs', type:'Restaurant/Atelier', tier:'featured', logo:'https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?w=100&q=80', discount:'15% off cooking classes', address:'444 Viger O, Montréal', active:true, commissionRate:0.05 },
  { id:'partner_002', name:'Terrasse Nelligan', type:'Bar/Resto', tier:'premium', logo:'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=100&q=80', discount:'10% off dinner for 2', address:'106 Saint-Paul O, Montréal', active:true, commissionRate:0.15 },
  { id:'partner_003', name:'Escape Game Montréal', type:'Activity', tier:'basic', logo:'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=100&q=80', discount:'15% on all rooms', address:'1234 Rue Sainte-Catherine', active:true, commissionRate:0 },
];

// DEV SEED ONLY — data in supabase/seed/dev_seed.sql
export const MOCK_SPONSORS = [
  { id:'spon_001', name:'Fleurs Urbaines', tier:'story', startDate:'2025-04-01', endDate:'2025-04-30', status:'active', budget:299, spend:150, reach:340, content:'💐 Offer a bouquet for your first date — 20% off with code BEELOVE', network:'ca_montreal' },
  { id:'spon_002', name:'Vignoble Saint-Denis', tier:'question', startDate:'2025-04-07', endDate:'2025-04-13', status:'active', budget:149, spend:149, reach:890, content:'This week\'s question brought to you by Vignoble Saint-Denis: What does your perfect wine-and-dine evening look like?', network:'all' },
];

// ── Helpers ───────────────────────────────────────────────────────────────
export function getEventPrice(event, user) {
  const plan = user?.plan || user?.plan || 'free';

  // New schema: event_pricing array (from events_full view or joined query)
  // Falls back to legacy flat fields for backward compat with mock data
  if (Array.isArray(event.pricing)) {
    const row = event.pricing.find(p => p.plan === plan);
    if (row) return row.price;
    const free = event.pricing.find(p => p.plan === 'free');
    return free ? free.price : 0;
  }

  // Legacy flat fields (mock data + events_full view columns)
  if (plan === 'royal' || plan === 'founder') {
    if (event.royal_free || event.royalFree || event.gold_free || event.goldFree) return 0;
    return event.price_royal ?? event.priceRoyal ?? event.price_gold ?? event.priceGold ?? event.price ?? 0;
  }
  if (plan === 'honey') return event.price_honey ?? event.priceHoney ?? event.price ?? 0;
  return event.price ?? 0;
}

export function getSpotsLeft(event) {
  return Math.max(0, event.capacity - event.registered);
}

export function formatEventDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-CA', { weekday:'long', month:'long', day:'numeric' });
}

